import { render, staticRenderFns } from "./RoleIndex.vue?vue&type=template&id=59a328ee"
import script from "./RoleIndex.vue?vue&type=script&lang=js"
export * from "./RoleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports